export const BACKDROP_TRANSITION_DURATION_MS_DEFAULT = 300;
export const ENQUIRY_FORM_SUGGESTIVE_TRADE_IN_TEXT = 'I have a car to trade-in.'; // @suppress longLineCheck
export const ENQUIRY_FORM_SUGGESTIVE_DOWNPAYMENT_TEXT = 'What is the min. downpayment?'; // @suppress longLineCheck
export const ENQUIRY_FORM_SUGGESTIVE_LOAN_TEXT = 'I am taking 90% loan.'; // @suppress longLineCheck
export const ENQUIRY_FORM_SUGGESTIVE_INSTALMENT_TEXT = 'What is the monthly instalment?'; // @suppress longLineCheck
export const ENQUIRY_FORM_SUGGESTIVE_STOCK_TEXT = 'Do you have any ready stocks?'; // @suppress longLineCheck
export const MODAL_STEP_START = 'start';
export const MODAL_STEP_UNKNOWN_ERROR = 'error';
export const MODAL_STEP_SUCCESS = 'success';
export const MODAL_SUCCESS_MESSAGE = 'Thank you for your submission. Our partner dealers will reach out to you shortly with more information about the car you\'re interested in.';// @suppress longLineCheck
export const REG_SOURCE_NC_ENQUIRY_SPOTLIGHT = 'sgcm-nc-enquiry-spotlight';
export const REG_SOURCE_NC_ENQUIRY = 'sgcm-nc-enquiry';
